import { create } from "zustand";

const STORAGE_KEY = "thread-layout-mode";

type LayoutMode = "standard" | "advanced";

interface LayoutModeState {
  mode: LayoutMode;
  setMode: (mode: LayoutMode) => void;
  toggle: () => void;
}

export const useLayoutModeStore = create<LayoutModeState>((set) => ({
  mode: (() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "advanced") return "advanced" as const;
    } catch { /* noop */ }
    return "standard" as const;
  })(),
  setMode: (mode) => {
    set({ mode });
    try { localStorage.setItem(STORAGE_KEY, mode); } catch { /* noop */ }
  },
  toggle: () => set((state) => {
    const next = state.mode === "standard" ? "advanced" : "standard";
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* noop */ }
    return { mode: next };
  }),
}));
